import { render, staticRenderFns } from "./UserGrader.vue?vue&type=template&id=84caa5a0&"
import script from "./UserGrader.vue?vue&type=script&lang=js&"
export * from "./UserGrader.vue?vue&type=script&lang=js&"
import style0 from "./UserGrader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports